import axios from 'axios';
import config from '../config';

export const METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
};

export const call = async (endpoint, method = METHODS.GET, token = null, data = null) => {
    try {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const axiosConfig = {
            method,
            url: `${config.API_URL}${endpoint}`,
            headers,
            data: method !== METHODS.GET ? data : null,
            params: method === METHODS.GET ? data : null
        };

        const response = await axios(axiosConfig);
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        if (error.response) {
            const status = error.response.status;
            if (status === 401 || status === 403) {
                try {
                    localStorage.removeItem('token');
                    localStorage.removeItem('userDetails');
                } catch (_) {}
                if (typeof window !== 'undefined') {
                    if (window.location.hash !== '#/login') {
                        window.location.hash = '#/login';
                    }
                }
            }
            return {
                status: error.response.status,
                error: error.response.data.message || error.response.data
            };
        }
        return {
            status: 500,
            error: error.message
        };
    }
};